// tldraw license key. Domain-locked and intended to ship in the client bundle
// (per tldraw docs), so a VITE_ env var is the correct home. When unset,
// tldraw runs unlicensed: console warning + "Made with tldraw" watermark.
export const TLDRAW_LICENSE_KEY = import.meta.env.VITE_TLDRAW_LICENSE_KEY as
  | string
  | undefined;
